// URLA 2020 Section 1e income sources. `other_income_type` stores the code;
// rows saved before this list hold free text, which shows as typed.
export const OTHER_INCOME_TYPES = [
  ['alimony', 'Alimony'],
  ['automobile_allowance', 'Automobile Allowance'],
  ['boarder_income', 'Boarder Income'],
  ['capital_gains', 'Capital Gains'],
  ['child_support', 'Child Support'],
  ['disability', 'Disability'],
  ['foster_care', 'Foster Care'],
  ['housing_parsonage', 'Housing or Parsonage'],
  ['interest_dividends', 'Interest and Dividends'],
  ['mortgage_credit_certificate', 'Mortgage Credit Certificate'],
  ['mortgage_differential', 'Mortgage Differential Payments'],
  ['notes_receivable', 'Notes Receivable'],
  ['public_assistance', 'Public Assistance'],
  ['retirement', 'Retirement (Pension, IRA)'],
  ['royalty_payments', 'Royalty Payments'],
  ['separate_maintenance', 'Separate Maintenance'],
  ['social_security', 'Social Security'],
  ['trust', 'Trust'],
  ['unemployment', 'Unemployment Benefits'],
  ['va_compensation', 'VA Compensation'],
  ['other', 'Other'],
];

const LABELS = Object.fromEntries(OTHER_INCOME_TYPES);

export function otherIncomeLabel(row) {
  const type = row?.other_income_type;
  if (type === 'other' && row.other_income_description) return row.other_income_description;
  return LABELS[type] || type || 'Other income';
}

// Options for a select, keeping a legacy free-text value pickable so it still shows.
export function otherIncomeOptions(current) {
  return current && !LABELS[current] ? [[current, current], ...OTHER_INCOME_TYPES] : OTHER_INCOME_TYPES;
}
